import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 6l6 6l-6 6","key":"svg-0"}],["path",{"d":"M17 5v13","key":"svg-1"}]]

/**
 * IconChevronRightPipe
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hldnJvbi1yaWdodC1waXBlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik02IDZsNiA2bC02IDYiIC8+CiAgPHBhdGggZD0iTTE3IDV2MTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/chevron-right-pipe
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChevronRightPipe = createReactComponent('outline', 'chevron-right-pipe', 'ChevronRightPipe', __iconNode);

export default IconChevronRightPipe;